import { createSlice } from '@reduxjs/toolkit';

import { status } from 'utils/const';
import { thunks } from './thunks';
import { selectors } from './selectors';

const initialState = {
  pagination: {
    current: 1,
    total: 0,
  },
  loadingNotesStatus: status.IDLE,
};

const slice = createSlice({
  name: 'notes',
  initialState,
  reducers: {
    setPage: (state, { payload }) => {
      state.pagination.current = payload;
    },
  },
});

const notes = {
  actions: slice.actions,
  selectors,
  thunks,
};

export { notes };
export default slice.reducer;
